module.exports = __webpack_public_path__ + "static/media/illo_editor.33871691.svg";